// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"353f19c6","453":"e7be83c3","455":"f57f54fd","977":"92b5cf3a"}[chunkId] + ".chunk.js";
};